// app.jsx — 라우팅과 **세션 갈림길**.
//
// ux §2.2 의 라우트 표를 그대로 옮긴다. Space 가 URL 에 있어야 새로고침·딥링크·뒤로가기가
// Space 를 떨어뜨리지 않는다.
//
// 중요한 결정 하나: **알 수 없는 spaceId 로 들어와도 첫 진입으로 튕기지 않는다.**
// 「이 Space를 읽을 수 없습니다」 화면에 남아 참여 신청 또는 Space 전환을 제시한다.
// 튕기면 사람은 자기가 뭘 잘못했는지 모른 채 처음으로 돌아간다.

import { Route, Switch, useLocation } from 'wouter-preact';
import { SESSION, useSession } from './session/session.jsx';
import { Entry } from './routes/Entry.jsx';
import { Onboarding } from './routes/Onboarding.jsx';
import { NodeSelection } from './routes/NodeSelection.jsx';
import { SignedOut } from './routes/SignedOut.jsx';
import { SpaceShell } from './routes/SpaceShell.jsx';
import { ErrorView, Loading } from './ui/states.jsx';
import './app.css';

export function App() {
  const session = useSession();

  // 세션 갈림길이 라우터보다 먼저다. 세션이 정해지기 전에는 어떤 화면도 그리지 않는다 —
  // 이것이 「서버가 아직 아무 말도 안 했는데 화면이 뭔가 있는 척」을 막는 자리다.
  switch (session.status) {
    case SESSION.LOADING:
      return (
        <main class="boot">
          <Loading label="세션을 확인하는 중" />
        </main>
      );

    case SESSION.ANONYMOUS:
      return <SignedOut />;

    case SESSION.NEEDS_ONBOARDING:
      return <Onboarding onDone={session.reload} />;

    case SESSION.NEEDS_NODE_SELECTION:
      return (
        <NodeSelection
          candidates={session.candidates}
          error={session.error}
          onSelect={session.selectNode}
        />
      );

    case SESSION.ERROR:
      return (
        <main class="boot">
          <ErrorView error={session.error} onRetry={session.reload} />
        </main>
      );

    case SESSION.READY:
    default:
      return <Routes />;
  }
}

function Routes() {
  const [location] = useLocation();

  return (
    <Switch location={location}>
      <Route path="/" component={Entry} />
      {/* 이미 사람 Node 가 있는데 /onboarding 으로 오면 첫 진입으로 보낸다. */}
      <Route path="/onboarding" component={Entry} />
      <Route path="/s/:spaceId" component={SpaceShell} />
      <Route path="/s/:spaceId/*" component={SpaceShell} />
      <Route>
        <NotFound />
      </Route>
    </Switch>
  );
}

function NotFound() {
  const [, navigate] = useLocation();
  return (
    <main class="boot">
      <ErrorView
        error={{ status: 404, code: 'route_not_found' }}
        onRetry={() => navigate('/', { replace: true })}
      />
    </main>
  );
}
